jQuery(document).ready(function ($) {
  if ($("#order-info").length) {
    $(
      "#account_service_first_name, #account_service_last_name, #account_service_contact_phone, #account_service_contact_email"
    ).on("blur", function () {
      if (checkSalesforceFields()) {
        console.log(
          "All Required Fields for Salesforce Submission are complete"
        );
        setSalesforcePartialContact(false, "add");
        setSalesforcePartialContact(false, "update");
      } else {
        console.log("Fields Required to Complete Salesforce Submission");
      }
    });

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (checkSalesforceFields() && checkSalesforceAddressFields()) {
          console.log(
            "All Required Fields + Address for Salesforce Submission are complete"
          );
          setSalesforcePartialContact(false, "add");
          setSalesforcePartialContact(false, "update");
        } else {
          console.log(
            "Fields Required + Address to Complete Salesforce Submission"
          );
        }
      });
    });

    // Look for class changes on address checker container
    observer.observe($("#addressCheckerModal")[0], {
      attributes: true,
      attributeFilter: ["class"],
    });
  }
});

function checkSalesforceFields() {
  var $ = jQuery;
  if ($("#order-customer-info").length) {
    var nameValid = false;
    var phoneValid =
      $("#account_service_contact_phone").valid() &&
      $("#account_service_contact_phone").val();
    var emailValid =
      $("#account_service_contact_email").valid() &&
      $("#account_service_contact_email").val();

    if (
      $("#account_service_first_name").valid() &&
      $("#account_service_first_name").val() &&
      $("#account_service_last_name").valid() &&
      $("#account_service_last_name").val()
    ) {
      nameValid = true;
    }
    return nameValid && phoneValid && emailValid;
  }
  return false;
}

function checkSalesforceAddressFields() {
  if ($("#order-customer-info").length) {
    return (
      localStorage.getItem("lumos_address_full_address") &&
      localStorage.getItem("lumos_address_street") &&
      localStorage.getItem("lumos_address_city") &&
      localStorage.getItem("lumos_address_state")
    );
  }
  return false;
}

function setSalesforcePartialContact(isCustomer = false, formAction) {
  $.ajax({
    url: "/wp-content/themes/lumos-tidewater/api_helper.php",
    type: "GET",
    dataType: "json",
    async: false,
    data: {
      action: "get_server_info",
    },
    success: function (result) {
      var externalKey = "";
      var dripKey = "";
      // if using dev aq (indicating dev env), use dev keys
      if (!(result.env === "live")) {
        externalKey = "98526E36-63B5-441D-ACA1-A771EE977365"; //order_customer_info
        dripKey = "D2FB957F-358A-43E4-9F5E-E7ECF4475BCF"; //presell conditioning
        nflDripKey = "0A43CADF-6B17-4C40-879E-9D83D7893873"; //nfl ddrip
        abandonDripKey = "1C246F0F-F3BE-4815-B9EF-F2A3E9794D53"; //abandoned cart drip
        customerKey = "DB017DA9-FCBA-4A80-B38A-2CF98EA73459"; //customer type extension
        clientId = "534009359";
      } else {
        externalKey = "757AB2FA-9E9C-4132-A977-0F2F1A3164AF";
        dripKey = "E877F2B8-3989-4F7B-9CF3-86B7A74E213F";
        nflDripKey = "889D1806-221F-4A61-8E81-032C9FBFE1CE";
        abandonDripKey = "DFAC199A-5767-4F72-867B-E1B1ED35F8C8";
        customerKey = "D26D8941-01CC-4F0E-82B2-F60D64009ACF";
        clientId = "534005590";
      }
      if ($("#order-customer-info").length) {
        // Set Customer Type
        var customerType = "Opportunity";
        if (isCustomer) {
          customerType = "Registered Customer";
        }

        // set customer type
        var sfCustomerTypeFormData = new FormData();
        sfCustomerTypeFormData.append("_clientId", clientId);
        sfCustomerTypeFormData.append("_deExternalKey", customerKey);
        sfCustomerTypeFormData.append("_action", formAction);
        sfCustomerTypeFormData.append("_returnXML", "0");
        sfCustomerTypeFormData.append(
          "_successURL",
          "https://example.com/success"
        );
        sfCustomerTypeFormData.append("_errorURL", "https://example.com/error");

        sfCustomerTypeFormData.append(
          "ContactKey",
          $("#account_service_contact_email").val()
        );
        sfCustomerTypeFormData.append(
          "Email",
          $("#account_service_contact_email").val()
        );
        sfCustomerTypeFormData.append("CustomerType", customerType);

        updateSalesforceDataExtension(sfCustomerTypeFormData);

        // submit to form submission tracking endpoint
        var sfInfoFormData = new FormData();
        sfInfoFormData.append("_clientId", clientId);
        sfInfoFormData.append("_deExternalKey", externalKey);
        sfInfoFormData.append("_action", "add");
        sfInfoFormData.append("_returnXML", "0");
        sfInfoFormData.append("_successURL", "https://example.com/success");
        sfInfoFormData.append("_errorURL", "https://example.com/error");
        sfInfoFormData.append(
          "ContactKey",
          $("#account_service_contact_email").val()
        );
        sfInfoFormData.append(
          "FirstName",
          $("#account_service_first_name").val()
        );
        sfInfoFormData.append(
          "LastName",
          $("#account_service_last_name").val()
        );
        sfInfoFormData.append(
          "Phone",
          $("#account_service_contact_phone").val()
        );
        sfInfoFormData.append(
          "Email",
          $("#account_service_contact_email").val()
        );
        sfInfoFormData.append("CustomerType", customerType);

        if (
          localStorage.getItem("lumos_address_full_address") &&
          localStorage.getItem("lumos_address_street") &&
          localStorage.getItem("lumos_address_city") &&
          localStorage.getItem("lumos_address_state")
        ) {
          sfInfoFormData.append(
            "Street",
            localStorage.getItem("lumos_address_street")
          );
          sfInfoFormData.append(
            "City",
            localStorage.getItem("lumos_address_city")
          );
          sfInfoFormData.append(
            "State",
            localStorage.getItem("lumos_address_state")
          );
        }

        updateSalesforceDataExtension(sfInfoFormData);

        // qualify for drip marketing journey(s) by customer type
        if (isCustomer) {
          // if registered, nfl redzone
          var sfNflFormData = new FormData();
          sfNflFormData.append("_clientId", clientId);
          sfNflFormData.append("_deExternalKey", nflDripKey);
          sfNflFormData.append("_action", "add");
          sfNflFormData.append("_returnXML", "0");
          sfNflFormData.append("_successURL", "https://example.com/success");
          sfNflFormData.append("_errorURL", "https://example.com/error");
          sfNflFormData.append(
            "ContactKey",
            $("#account_service_contact_email").val()
          );
          sfNflFormData.append(
            "FirstName",
            $("#account_service_first_name").val()
          );
          sfNflFormData.append(
            "LastName",
            $("#account_service_last_name").val()
          );
          sfNflFormData.append(
            "Phone",
            $("#account_service_contact_phone").val()
          );
          sfNflFormData.append(
            "Email",
            $("#account_service_contact_email").val()
          );
          sfNflFormData.append("CustomerType", customerType);

          if (
            localStorage.getItem("lumos_address_full_address") &&
            localStorage.getItem("lumos_address_street") &&
            localStorage.getItem("lumos_address_city") &&
            localStorage.getItem("lumos_address_state")
          ) {
            sfNflFormData.append(
              "Street",
              localStorage.getItem("lumos_address_street")
            );
            sfNflFormData.append(
              "City",
              localStorage.getItem("lumos_address_city")
            );
            sfNflFormData.append(
              "State",
              localStorage.getItem("lumos_address_state")
            );
          }

          updateSalesforceDataExtension(sfNflFormData);
        } else {
          // get tech_stack and promo_zone details for abandoned cart orders
          let tech_stack = localStorage.getItem("lumos_address_tech_stack").toLowerCase();
          let promo_zone = localStorage.getItem("lumos_address_promotion_zone").toLowerCase();

          // if unregistered, abandoned cart drip
          var sfAbandonedFormData = new FormData();
          sfAbandonedFormData.append("_clientId", clientId);
          sfAbandonedFormData.append("_deExternalKey", abandonDripKey);
          sfAbandonedFormData.append("_action", "add");
          sfAbandonedFormData.append("_returnXML", "0");
          sfAbandonedFormData.append(
            "_successURL",
            "https://example.com/success"
          );
          sfAbandonedFormData.append("_errorURL", "https://example.com/error");
          sfAbandonedFormData.append(
            "ContactKey",
            $("#account_service_contact_email").val()
          );
          sfAbandonedFormData.append(
            "FirstName",
            $("#account_service_first_name").val()
          );
          sfAbandonedFormData.append(
            "LastName",
            $("#account_service_last_name").val()
          );
          sfAbandonedFormData.append(
            "Phone",
            $("#account_service_contact_phone").val()
          );
          sfAbandonedFormData.append(
            "Email",
            $("#account_service_contact_email").val()
          );
          sfAbandonedFormData.append("CustomerType", customerType);          
          sfAbandonedFormData.append("TechStack", tech_stack);
          sfAbandonedFormData.append("PromoZone", promo_zone);

          if (
            localStorage.getItem("lumos_address_full_address") &&
            localStorage.getItem("lumos_address_street") &&
            localStorage.getItem("lumos_address_city") &&
            localStorage.getItem("lumos_address_state")
          ) {
            sfAbandonedFormData.append(
              "Street",
              localStorage.getItem("lumos_address_street")
            );
            sfAbandonedFormData.append(
              "City",
              localStorage.getItem("lumos_address_city")
            );
            sfAbandonedFormData.append(
              "State",
              localStorage.getItem("lumos_address_state")
            );
          }

          updateSalesforceDataExtension(sfAbandonedFormData);
        }

        hasInitialContactCapture = true;
      }
    },
  });
}

function updateSalesforceDataExtension(sfFormData) {
  $.ajax({
    type: "POST",
    url: "https://cl.s12.exct.net/DEManager.aspx",
    cache: false,
    processData: false,
    contentType: false,
    data: sfFormData,
    success: function (data) {
      console.log(data);
    },
  });
}
